import queryString from 'query-string';

export function getPageUrl(pageParam: number, requestUrl = '') {
  const { url, query } = queryString.parseUrl(
    typeof window === 'undefined' ? requestUrl : window.location.href
  );

  const qs = queryString.stringify({
    ...query,
    page: pageParam > 1 ? pageParam : undefined,
  });
  if (!qs) {
    return url;
  }

  return `${url}?${qs}`;
}

export function getPageUrlWithCursor(cursor?: string, requestUrl = '') {
  const { url, query } = queryString.parseUrl(
    typeof window === 'undefined' ? requestUrl : window.location.href
  );

  const qs = queryString.stringify({
    ...query,
    page: undefined,
    cursor,
  });
  if (!qs) {
    return url;
  }

  return `${url}?${qs}`;
}
